import { alpha, Box, Button, Typography } from '@mui/material'
import { isGuest } from '../../../../helpers'
import { Dialogs, useDialogs } from '../../../../sharedComponents/src/Contexts/DialogsContext'
import SignIn from '../../../../sharedComponents/src/Dialogs/Forms/SignIn'
import SignUp from '../../../../sharedComponents/src/Dialogs/Forms/SignUp'
import { useStoreState } from '../../../../store/hooks'

type GuestBlockerVariant = 'missions' | 'stats' | 'gameHistory'

interface GuestBlockerProps {
    variant?: GuestBlockerVariant
}

const variants = {
    missions: {
        header: 'Sign up for free to unlock missions & achievements.',
    },
    stats: {
        header: 'Sign up for free to unlock your stats.',
    },
    gameHistory: {
        header: 'Sign up for free to unlock your game history.',
    },
}

export const GuestBlocker = ({ variant = 'missions' }: GuestBlockerProps) => {
    const userData = useStoreState((state) => state.userData)
    const { registerDialog } = useDialogs()

    const guest = isGuest(userData.userData?.groups)
    if (!guest) return null

    const { header } = variants[variant]

    return (
        <>
            <Box
                id="guest-blocker-backdrop"
                sx={{
                    position: 'fixed',
                    top: 0,
                    left: 0,
                    right: 0,
                    bottom: 0,
                    width: '100%',
                    zIndex: 1000,
                    display: 'flex',
                    backgroundColor: (theme) => alpha(theme.palette.background.default, 0.9),
                    backdropFilter: 'blur(2px)',
                    opacity: 0.8,
                    pointerEvents: 'none',
                }}
            ></Box>
            <Box
                id="guest-blocker"
                sx={{
                    position: 'fixed',
                    top: 0,
                    left: 0,
                    right: 0,
                    bottom: 0,
                    zIndex: 1001,
                    display: 'flex',
                    flexDirection: 'column',
                    justifyContent: 'center',
                    overflow: 'auto',
                    margin: '0 auto',
                    alignItems: 'center',
                    filter: 'drop-shadow(0px 4px 6px rgba(0, 0, 0, 0.1))',
                }}
            >
                <Typography variant="h5" textAlign="center" paragraph>
                    {header}
                </Typography>
                <Button
                    variant="contained"
                    size="large"
                    color="primary"
                    onClick={() => registerDialog(Dialogs.SIGNUP, <SignUp />)}
                >
                    Sign Up
                </Button>
                <Typography variant="body1" textAlign="center" mt={2} paragraph>
                    Already have an account?
                </Typography>
                <Typography
                    variant="body1"
                    sx={{ textDecoration: 'underline', cursor: 'pointer' }}
                    textAlign="center"
                    onClick={() => registerDialog(Dialogs.SIGNIN, <SignIn />)}
                >
                    Sign in
                </Typography>
            </Box>
        </>
    )
}
